import RequestDetailsContainer from "./RequestDetailsContainer";
import RequestDetailsStore from "./RequestDetailsStore";
export default RequestDetailsStore(RequestDetailsContainer); 